<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">Boats</h1>
        <div class="mb-6 flex justify-between items-center">
            <inertia-link class="btn-primary" :href="route('manage.boats.create')">
                <span>Create</span>
                <span class="hidden md:inline">Boat</span>
            </inertia-link>
        </div>

      <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset">
        <div class="p-2">
          <label class="block text-gray-700">Approved Status:</label>
          <select v-model="form.approved" class="mt-1 w-full form-select">
            <option value="all">All</option>
            <option value="1">Approved</option>
            <option value="0">Not Approved</option>
          </select>
        </div>

        <div class="p-2">
          <label class="block text-gray-700">Tax:</label>
          <select v-model="form.atoll" class="mt-1 w-full form-select">
            <option :value="null">All</option>
            <option v-for="atoll in atoll_list" :value="atoll">{{ atoll }}</option>
          </select>
        </div>

      </search-filter>

      <div class="mb-4 hidden md:block">
        <div>
          <div class="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow md:grid-cols-4 xl:grid-cols-8">
            <div v-for="(card, index) in statCards"
                 :class="{'border-t border-gray-200 md:border-0 md:border-l': index > 0}">
              <div class="px-4 py-2 sm:p-3">
                <dl>
                  <dt class="text-base leading-6 font-normal text-gray-900">
                    {{ statuses[card] }}
                  </dt>
                  <dd class="mt-1 flex justify-between items-baseline sm:block md:flex">
                    <div class="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                      {{ stats[card] ? stats[card] : 0}}
                    </div>
                    <button class="btn-primary px-3 py-2" :disabled="!stats[card]"
                            @click="form.approved = card === 'approved' ? '1' : card === 'not_approved' ? '0' : null">View
                    </button>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="bg-white rounded shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="px-6 pt-6 pb-4">Name</th>
                    <th class="px-6 pt-6 pb-4">Atoll</th>
                    <th class="px-6 pt-6 pb-4">Primary Mobile#</th>
                    <th class="px-6 pt-6 pb-4">Secondary Mobile#</th>
                    <th class="px-6 pt-6 pb-4">Approved</th>
                </tr>
                <tr v-for="row in boats.data" :key="row.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('manage.boats.edit', row.id)">
                            {{ row.name }}
                            <icon v-if="row.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('manage.boats.edit', row.id)">
                            {{ row.atoll }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('manage.boats.edit', row.id)">
                          {{ row.primary_mobile }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.boats.edit', row.id)" tabindex="-1">
                          {{ row.secondary_mobile }}
                        </inertia-link>
                    </td>
                  <td class="border-t">
                    <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.boats.edit', row.id)" tabindex="-1">
                      <span v-if="row.approved == true">Yes</span>
                      <span v-else>No</span>
                    </inertia-link>
                  </td>
                    <td class="border-t w-px">
                        <inertia-link v-if="canAdmin('update-boats')" class="px-4 flex items-center" :href="route('manage.boats.edit', row.id)" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                        </inertia-link>
                    </td>
                </tr>
                <tr v-if="boats.data.length === 0">
                    <td class="border-t px-6 py-4" colspan="5">No boats found.</td>
                </tr>
            </table>
        </div>
        <pagination :links="boats.links" />
    </div>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Admin/Layout'
  import Pagination from '@/Shared/Pagination'
  import SearchFilter from '@/Shared/SearchFilter'
  import throttle from 'lodash/throttle'
  import pickBy from 'lodash/pickBy'

  export default {
    layout: Layout,
    components: {
      Icon,
      Pagination,
      SearchFilter
    },

    props: {
      boats: Object,
      atoll_list: Array,
      filters: Object,
      statuses: Object,
      statCards: Array,
      stats: Object,
    },

    data() {
      return {
        form: {
          search: this.filters.search || null,
          atoll: this.filters.atoll || null,
          approved: this.filters.approved || null
        }
      }
    },

    watch: {
      form: {
        handler: throttle(function () {
          let query = pickBy(this.form)
          this.$inertia.get(this.route('manage.boats', Object.keys(query).length ? query : { remember: 'forget'}), {}, { preserveState: true })
        }, 150),
        deep: true,
      },
    },

    methods: {
      reset() {
        this.form = {
          search: null,
          atoll: null,
          approved: null
        }
      }
    }
  }
</script>
